// Marcas do Facebook e do Instagram como SVG.
//
// O lucide-react tirou os ícones de marca a partir da 0.5x (só sobraram os
// genéricos), e trocar o "f" do Facebook por um ícone de compartilhar deixaria
// a lista de conexões ambígua. Desenhados aqui, seguem o tema: herdam a cor de
// quem os usa.

export const FacebookIcon = ({ className }) => (
	<svg
		viewBox="0 0 24 24"
		fill="currentColor"
		aria-hidden="true"
		className={className}
	>
		<path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.52 1.49-3.91 3.77-3.91 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.78-1.63 1.57v1.89h2.78l-.44 2.91h-2.34V22c4.78-.76 8.44-4.92 8.44-9.94Z" />
	</svg>
);

export const InstagramIcon = ({ className }) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
		className={className}
	>
		<rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
		<path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37Z" />
		<line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
	</svg>
);
